import { render, staticRenderFns } from "./fexam.vue?vue&type=template&id=c5c91392&scoped=true&"
import script from "./fexam.vue?vue&type=script&lang=js&"
export * from "./fexam.vue?vue&type=script&lang=js&"
import style0 from "./fexam.vue?vue&type=style&index=0&id=c5c91392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c91392",
  null
  
)

export default component.exports